export default {"src":"/_next/static/media/half-circle-grey.319b2e27.svg","height":322,"width":643,"blurWidth":0,"blurHeight":0};